module.exports = __webpack_public_path__ + "img/mov.9e554a27.svg";